import { Tooltip } from '@c2fo/liquidity';
import { ArrowUpRightFromSquareIcon } from '@c2fo/liquidity/icons';
import { getCloudConsoleUrl } from '../../../../utils/cloudUrl';

interface UriLinkProps {
  uri: string;
  className?: string;
  showTooltip?: boolean;
  truncate?: boolean;
}

export const UriLink: React.FC<UriLinkProps> = ({ uri, className = '', showTooltip = true, truncate = true }) => {
  const cloudUrl = getCloudConsoleUrl(uri);

  const content = cloudUrl ? (
    <a
      href={cloudUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-1 text-primary-600 hover:text-primary-700 hover:underline ${truncate ? 'max-w-xs' : ''} ${className}`}
    >
      <span className={truncate ? 'truncate' : ''}>{uri}</span>
      <ArrowUpRightFromSquareIcon className="h-3 w-3 flex-shrink-0" />
    </a>
  ) : (
    <span className={`${truncate ? 'block max-w-xs truncate' : ''} ${showTooltip ? 'cursor-help' : ''} ${className}`}>
      {uri}
    </span>
  );

  if (!showTooltip) {
    return content;
  }

  return (
    <Tooltip.Provider>
      <Tooltip>
        <Tooltip.Trigger asChild>{content}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content variant="dark" arrow>
            {uri}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip>
    </Tooltip.Provider>
  );
};
